module.exports = __webpack_public_path__ + "img/logo-inline-light.8a0ed61e.svg";